import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Paper,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import CalculateIcon from "@mui/icons-material/Calculate";
import GroupIcon from "@mui/icons-material/Group";
import StorageIcon from "@mui/icons-material/Storage";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * Sidebar – Fee-Admin navigation
 *
 * @param {("agents"|"data")} activeView  Current view key
 * @param {(view: "agents"|"data") => void} onViewChange  Handler to switch view
 */
const Sidebar = ({ activeView, onViewChange }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Paper
      elevation={1}
      sx={{
        width: 321,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          p: 1,
          paddingLeft: 0,
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          src="/assets/images/osa-logo.svg"
          alt="osa-logo"
          className="osa-logo"
        />
        <Box>
          <Typography variant="h6" fontWeight="bold">
            Admin
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Management System
          </Typography>
        </Box>
      </Box>

      {/* Nav */}
      <Box sx={{ flex: 1, p: 2 }}>
        <List disablePadding>
          <ListItemButton
            selected={location.pathname === "/admin/manage-agent"}
            onClick={() => {
              onViewChange("agents");
              navigate("/admin/manage-agent");
            }}
            sx={{
              borderRadius: 1,
              "&.Mui-selected": {
                backgroundColor: "black",
                "& .MuiListItemText-primary": {
                  color: "white",
                },
              },
              "&.Mui-selected:hover": {
                backgroundColor: "black",
              },
            }}
          >
            <ListItemIcon sx={{ color: "var(--primary)" }}>
              <GroupIcon />
            </ListItemIcon>
            <ListItemText primary="Agent URLs" />
          </ListItemButton>

          <ListItemButton
           selected={location.pathname === "/admin/manage-data"}
            onClick={() => {
              onViewChange("data");navigate("/admin/manage-data")
            }}
            sx={{
              borderRadius: 1,
              mt: 1,
              "&.Mui-selected": {
                backgroundColor: "black",
                "& .MuiListItemText-primary": {
                  color: "white",
                },
              },
              "&.Mui-selected:hover": {
                backgroundColor: "black",
              },
            }}
          >
            <ListItemIcon sx={{ color: "var(--primary)" }}>
              <StorageIcon />
            </ListItemIcon>
            <ListItemText
              primary="Manage Fees"
        
            />
          </ListItemButton>
        </List>
      </Box>

      <Divider />

      {/* Footer */}
      <Box sx={{ p: 2 }}>
        <Typography variant="caption" color="text.secondary">
          Admin Panel v1.0
        </Typography>
      </Box>
    </Paper>
  );
};

Sidebar.propTypes = {
  activeView: PropTypes.oneOf(["agents", "data"]).isRequired,
  onViewChange: PropTypes.func.isRequired,
};

export default Sidebar;
